export enum PropertyStatus {
  PRE_REGISTERED = "PRE_REGISTERED",
  PUBLISHED = "PUBLISHED",
  RENTED = "RENTED",
}

export const PROPERTY_STATUS_LABEL: Record<PropertyStatus, string> = {
  [PropertyStatus.PRE_REGISTERED]: "Pré-cadastro",
  [PropertyStatus.PUBLISHED]: "Publicado",
  [PropertyStatus.RENTED]: "Alugado",
};

/**
 * The API exposes the draft status under several inconsistent labels across
 * endpoints (status name, list filter, persisted enum), so we normalize against
 * every known token instead of comparing a single literal.
 */
const DRAFT_STATUS_TOKENS = new Set<string>([
  "pre_registered",
  "pre_cadastrado",
  "pre-cadastrado",
  "pré-cadastrado",
  "pre_cadastro",
  "pre-cadastro",
  "pré-cadastro",
  "rascunho",
  "draft",
]);

export function isDraftStatus(status?: string | null): boolean {
  if (!status) return false;
  return DRAFT_STATUS_TOKENS.has(status.trim().toLowerCase());
}

/**
 * Maps raw API status tokens (e.g. PRE_CADASTRADO) to a short UI label.
 */
export function formatPropertyStatusLabel(status?: string | null): string {
  if (!status || !status.trim()) return "-";

  const trimmed = status.trim();
  if (isDraftStatus(trimmed)) {
    return PROPERTY_STATUS_LABEL[PropertyStatus.PRE_REGISTERED];
  }

  const normalized = trimmed.toLowerCase().replace(/_/g, " ");

  if (normalized.includes("alug") || normalized === "rented") {
    return PROPERTY_STATUS_LABEL[PropertyStatus.RENTED];
  }

  if (normalized.includes("public") || normalized === "published") {
    return PROPERTY_STATUS_LABEL[PropertyStatus.PUBLISHED];
  }

  if (normalized.includes("desativ") || normalized.includes("inativ")) {
    return "Inativo";
  }

  // Title-case unknown labels without shouting enum-style tokens.
  return trimmed
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
